import { getActiveFiltersQuery } from '@common/Filters/helpers/filters';
import { filtersMap } from '@common/Filters/helpers/filtersMap';
import { getLimitValue } from '@common/Listing/helpers';

export const getQueryFromFilters = (state, page) => {
    const { filters, sortBy, listing } = state;
    const { activeFilters } = filters;
    const { limit, gridView, gridViewFromConfig } = listing;

    return getActiveFiltersQuery(activeFilters, limit, page, gridViewFromConfig ?? gridView, sortBy);
};

const getOrderValue = (searchQuery) => {
    const order = searchQuery.get('order');
    const personalCategory = searchQuery.get('personalcategory');

    if (personalCategory) {
        return 1;
    }

    return order ?? null;
};

export const getFiltersParameters = searchQuery => Object.keys(filtersMap).reduce((acc, filterKey) => {
    const attribute = searchQuery.get(filterKey);

    if (attribute) {
        acc[filterKey] = attribute;
    }

    return acc;
}, {});

/**
 * Returns query parsed from url parameters
 *
 * @param {Object} limit
 * @return {Object}
 */
export const getQueryFromUrl = (limit) => {
    const searchQuery = new URLSearchParams(window.location.search);
    const searchKey = searchQuery.get('search_key');
    const urlGridView = searchQuery.get('grid');
    const order = getOrderValue(searchQuery);
    const page = searchQuery.get('page') ?? 1;

    const params = {
        limit: getLimitValue(limit),
        page: Number(page),
        ...urlGridView && { grid: urlGridView },
        ...searchKey && { search_key: searchKey },
        ...!!order && { order },
        ...getFiltersParameters(searchQuery)
    };

    return Object.keys(params).sort().reduce((sortedObject, paramKey) => {
        sortedObject[paramKey] = params[paramKey];
        return sortedObject;
    }, {});
};
